export const getEnvVar = (name, defaultVal = '') => process.env[`REACT_APP_${name}`] || defaultVal;

export const API_URL = getEnvVar('API_URL', '');

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

export const get = (url) => fetch(url, {headers}).then(r => r.json());

export const getExpenses = () => get(API_URL + "/tables/expenses");
export const getPensionPlan = () => get(API_URL + "/tables/pension_plan");
export const getPremiumLadder = () => get(API_URL + "/tables/premium-ladder");
export const getLifeCycle = () => get(API_URL + "/tables/life-cycle");